import { render, staticRenderFns } from "./registration-confirmation.vue?vue&type=template&id=11a102e0&"
import script from "./registration-confirmation.vue?vue&type=script&lang=js&"
export * from "./registration-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./registration-confirmation.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "registration-confirmation.vue"
export default component.exports